import { Component } from '@angular/core';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { CandidateClientService } from './services/new-candidate-client.service';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { VERSION } from 'environments/version';


declare function require(path: string);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [CandidateClientService],
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  redirectUrl: string;
  logoSrc: any ;

  public year : String = formatDate(new Date(), 'yyyy', 'pl');
  public version : String = VERSION;

  constructor(candidateClientService: CandidateClientService, private router: Router) {
  }
  ngOnInit(): void {
  }
  
  title = 'application';
}
